//@flow
export default {
  secondsAgo: '{0} 秒前',
  minutesAgo: '{0} 分钟前',
  hoursAgo: '{0} 小时前',
  daysAgo: '{0} 天前',
  monthsAgo: '{0} 个月前',
  yearsAgo: '{0} 年前',
  secondsLeft: '{0} second{1} left',
  minutesLeft: '{0} minute{1} left',
  hoursLeft: '{0} hour{1} left',
  daysLeft: '{0} day{1} left',
  monthsLeft: '{0} month{1} left',
  yearsLeft: '{0} year{1} left',
  apiCannotBeReached: '无法调用API“{0}”',
  errorCode: {
    alreadyExist: '{0} already exists',
    somethingError: 'Something went wrong, please try again',
    clientPhoneWrong: 'Phone number is not correct'
  },
  noActivity: 'No Activity',
  noActivityDesc: 'There is no activity at the moment.',
  noTransactions: 'No transactions',
  noTransactionsDesc: 'You don’t have any info card transactions yet.',
  emptyPortfolio: 'Empty Portfolio',
  emptyPortfolioDesc: 'Client portfolio is currently empty.'
}
